<template>
    <div class="invitaciones">
        <h2 class="subheading grey--text">{{$t('Invitaciones')}}</h2>

        <v-container class="my-5">
            <v-layout calign-center >
                <v-flex>
                    <v-card class="elevation-5">
                        <v-toolbar class="mb-5" dark color="primary">
                            <v-toolbar-title>
                                {{$t('Invitaciones')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <h3>{{$t('mostrando_inv_dia')}}  {{date}}</h3>
                            <v-form
                                    @submit.prevent="submit()">
                                <v-layout row wrap>
                                    <v-flex xs6>
                                        <v-menu
                                                v-model="calendario"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="date"
                                                        prepend-icon="event"
                                                        name="date"
                                                        :label="$t('Fecha')"
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date"
                                                    @input="calendario = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn
                                                color="primary"
                                                type="submit"
                                        >{{ $t('Filtrar') }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-form>

                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_invita"
                            :items="invitaciones"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :rows-per-page-items="[
                                {
                                    text: '5',
                                    value: 5
                                },
                                {
                                    text: '10',
                                    value: 10
                                },
                                {
                                    text: '25',
                                    value: 25
                                },
                                {
                                    text: this.$t('todos'),
                                    value: -1
                                }
                            ]"
                            class="elevation-1"
                            :no-data-text="$t('no_registros_invit')"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        small
                                        class="mr-2"
                                        @click="fill_fields(props.item),
                                        dialog = true,
                                        id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                            </td>
                            <td>{{ props.item.id }}</td>
                            <td>{{ props.item.id }}</td>
                            <td>{{ props.item.fecha_hora_invitacion }}</td>
                            <td>{{ props.item.guestFirstName }} {{ props.item.guestLastName}}</td>
                            <td>{{ props.item.empresa }}</td>
                            <td>{{ props.item.guestCellPhone}}</td>
                            <td>{{ props.item.hostFirstName }} {{ props.item.hostLastName }}</td>
                        </template>
                        <template v-slot:rows-per-page-text="props">
                            Hola
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('Empleados')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import {mapState} from 'vuex'

    export default {
        name: "visitas_pendientes",
        data: () => ({
            alerta: false,
            calendario: false,
            fecha_actual: '',
            date: '',
            errores: [],
            search: '',
            headers: [],
            invitaciones:[],
            loading_data_invita: false,
            yyyy: '',
            mm: '',
            dd: ''
        }),
        created: function(){
            this.fecha_actual = this.get_current_date()
            this.date = this.fecha_actual
            this.get_invitaciones(this.yyyy, this.mm, this.dd)
        },
        beforeUpdate() {
            this.headers = [
                {
                    text: this.$t('modificar'),
                    align: 'left',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: 'ID',
                    align: 'left',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: this.$t('Tipo'),
                    align: 'left',
                    sortable: true,
                    value: 'tipo'
                },
                {
                    text: this.$t('fecha_hora'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_invitacion'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guestFirstName'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('telefono'),
                    align: 'left',
                    sortable: true,
                    value: 'guestCellPhone'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'hostFirstName'
                }
            ]
        },
        computed: {
            ...mapState(['language'])
        },
        methods:{
            get_current_date: function (){
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }

                if(this.mm<10)
                {
                    this.mm='0'+this.mm;
                }
                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                return today
            },
            split_date: function(date){
                var arr = date.split('-')

                this.yyyy = arr[0]
                this.mm = arr[1]
                this.dd = arr[2 ]
            },
            get_invitaciones: function (yyyy, mm, dd) {
                this.loading_data_invita = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_inv/' + yyyy + '/'  + mm + '/' + dd + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.invitaciones = response.data
                this.loading_data_invita = false
                    })
                    .catch(error => {
                        this.loading_data_invita = false
                        console.log(error)
                    })

            },
            submit: function(){
                this.split_date(this.date)
                this.get_invitaciones(this.yyyy, this.mm, this.dd)
            }
        }
    }
</script>

<style scoped>

</style>
